import {
  FeatureFlag,
  useNoUserFeatureFlagWithStatus,
} from "@vega-api/extended/auth/useFeatureFlag";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";

import { LPRegistrationLegacy } from "./LPRegistrationLegacy";
import { LPRegistrationNew } from "./LPRegistrationNew";

export const LPRegistration = () => {
  // The registration page is reached before authentication, so the flag must be
  // read via the pre-auth hook; the post-auth useFeatureFlag never resolves here
  // (no userId) and would always fall through to the legacy flow.
  const { isEnabled, isLoading } = useNoUserFeatureFlagWithStatus(
    FeatureFlag.GP_AUTH_INVITATION_V2,
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isEnabled ? <LPRegistrationNew /> : <LPRegistrationLegacy />;
};
